export const FAMILY = {
  FOSSIL_THERMAL: 'fossil-thermal',
  NUCLEAR: 'nuclear',
  SOLAR: 'solar',
  WIND: 'wind',
  OCEAN: 'ocean',
  HYDRO: 'hydro',
  GEOTHERMAL: 'geothermal'
};

export const FAMILY_LABEL = {
  [FAMILY.FOSSIL_THERMAL]: 'Fossil Thermal',
  [FAMILY.NUCLEAR]: 'Nuclear',
  [FAMILY.SOLAR]: 'Solar',
  [FAMILY.WIND]: 'Wind',
  [FAMILY.OCEAN]: 'Ocean',
  [FAMILY.HYDRO]: 'Hydro',
  [FAMILY.GEOTHERMAL]: 'Alternative Clean',
  // Advanced Capacity Mode storage family; not part of the Classic
  // FAMILY set (families used for disaster targeting and awards).
  storage: 'Storage'
};

export const FAMILIES = Object.values(FAMILY);
